import { useGetSoftwareInformationById } from "../API/softwareInformation.api";
import { useGetAllSubscriptionPayment } from "../API/subscriptionPayment.api";
import calculateDueMonths from "../utils/calculateDueMonths";

const useSubscriptionExpired = () => {
	const { data: allSubscriptionPayment } = useGetAllSubscriptionPayment();
	const { data: softwareInformation } = useGetSoftwareInformationById(1);

	const dueMonths = calculateDueMonths(
		allSubscriptionPayment,
		softwareInformation?.due_month_count_from,
	);

	const isExpiredWarningShow = dueMonths?.length > 0;

	const popupShowDate = new Date().setDate(
		softwareInformation?.expired_popup_show_date,
	);

	const isExpiredPopUpShow = isExpiredWarningShow && popupShowDate < new Date();
	new Date();

	const isFinalExpired =
		isExpiredWarningShow &&
		new Date().setDate(softwareInformation?.final_expired_date) < new Date();

	return {
		dueMonths,
		softwareInformation,
		allSubscriptionPayment,
		isExpiredWarningShow,
		isExpiredPopUpShow,
		isFinalExpired,
	};
};

export default useSubscriptionExpired;
